module.exports = __webpack_public_path__ + "4917cb53c94d712037f8f7b16818530a.svg";